<template>
  <v-card class="com-pc-card">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ text.hzdLink }}</span>
    </v-row>
    <v-col class="com-pc-card-contents">
      <v-row v-if="isAttention" no-gutters class="ml-2">
        <span>
          ハザードマップへのリンクを表示するには、
          <br />地図を拡大してください。
        </span>
      </v-row>
      <v-row
        v-if="
          !isAttention &&
            (Object.keys(this.hazardList).length == 0 ||
              Object.keys(this.$store.state.map.towns).length == 0)
        "
        no-gutters
        class="ml-2"
      >
        <span>表示できるハザードマップが見つかりませんでした。</span>
      </v-row>
      <div
        v-if="
          !isAttention &&
            Object.keys(this.hazardList).length != 0 &&
            Object.keys(this.$store.state.map.towns).length != 0
        "
        class="hzrd_map_frame"
      >
        <v-col class="rw-box-link pa-0">
          <div>
            <v-row no-gutters>
              <span class="pl-1" v-for="item in hazardList" :key="item.twnNm">
                <v-btn
                  text
                  :href="hazardUrl + item.mictwnCd"
                  target="_blank"
                  @click="clickHzdLink(item.mictwnCd)"
                  >{{ item.twnNm }}</v-btn
                >
              </span>
            </v-row>
          </div>
        </v-col>
      </div>
    </v-col>
  </v-card>
</template>
<script>
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "iu-link",
  data() {
    return {
      text: {
        hzdLink: "ハザードマップへのリンク",
      },
      hazardList: [],
      hazardUrl: "https://disaportal.gsi.go.jp/hazardmap/index.html?citycode=",
    };
  },
  computed: {
    /**
     * 表示範囲のハザードマップ一覧
     */
    hazardMap: {
      get() {
        return this.$store.state.inundation.hazardMap;
      },
    },
    /** 注意喚起表示 */
    isAttention: {
      get() {
        return (
          this.$store.state.map.zoom <
          this.$store.state.map.mapConfig.zoomInundation
        );
      },
    },
  },
  watch: {
    hazardMap(val) {
      this.hazardList = val;
    },
  },
  methods: {
    /** ハザードマップへのリンククリック */
    clickHzdLink(mictwnCd) {
      // アクセスログ出力
      PageLog.log({
        page_log: "inun_hazard",
        twn_cd: mictwnCd,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.sub-contents-title {
  font-weight: 600;
  font-size: 0.9rem;
}
.hzrd_map_frame {
  min-height: 36px;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  overflow: auto;
}
</style>
